import "./header.css";
import { Link } from "react-router-dom";
import logo from "../assest/logo1.png";

function Header() {
  return (
    <header>
      <Link to="/"><img src={logo} alt="Logo1" /></Link>
      <menu>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/About">About Us</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="koha-mls">Koha LMS </Link></li>
        <li><Link to="/career">Career</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
      </menu>
    </header>
  );
}

export default Header;
